import React from 'react';
import authRoles from '../../../auth/authRoles';
import ProductOwnerProfile from '../../../fuse-layouts/shared-components/adminDetail';
import Editprofile from '../../../fuse-layouts/shared-components/Editprofile';

const SuperAdminProfileConfig = {
	settings: {
		layout: {
			Config: {},
		},
	},
	routes: [
		{
			path: '/productOwnerprofile',
			element: (
				<React.Suspense fallback={<>...</>}>
					<ProductOwnerProfile />
				</React.Suspense>
			),
		},
		{
			path: '/Editprofile',
			element: (
				<React.Suspense fallback={<>...</>}>
					<Editprofile />
				</React.Suspense>
			),
		},
	],
	auth: authRoles.admin,
};

export default SuperAdminProfileConfig;
